var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconSaline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-saline_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161179",
  fill: "none",
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31343",
  clipPath: "url(#icon-saline_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38738",
  d: "M54.857 32A22.857 22.857 0 1132 9.143 22.857 22.857 0 0154.857 32",
  fill: "#f9a23a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38739",
  d: "M42.113 36.08a.147.147 0 01.181.143v.852c0 3.752-2.556 6.791-5.706 6.791H28.21c-3.151 0-5.706-3.04-5.706-6.791v-1.621a9.426 9.426 0 015.655-1.75c3.531 0 6.314 2.66 11.309 2.66a11.61 11.61 0 002.646-.285",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38740",
  d: "M28.151 32.943a13.665 13.665 0 014.924 1.208 16.9 16.9 0 006.386 1.452 10.913 10.913 0 002.473-.265l.086-.02h.122a.91.91 0 01.909.909v.852c0 4.165-2.9 7.553-6.468 7.553h-8.378c-3.567 0-6.468-3.388-6.468-7.553v-1.98l.277-.229a10.151 10.151 0 016.137-1.927zm11.309 4.184a18.394 18.394 0 01-6.928-1.552 12.358 12.358 0 00-4.381-1.108 9.008 9.008 0 00-4.893 1.378v1.23c0 3.325 2.218 6.029 4.945 6.029h8.378c2.726 0 4.945-2.7 4.945-6.029v-.108a12.6 12.6 0 01-2.063.16z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38741",
  d: "M42.291 20.216V35.99a.059.059 0 01-.044.057 11.481 11.481 0 01-2.783.318c-5 0-7.778-2.66-11.31-2.66a9.426 9.426 0 00-5.655 1.75V20.216a3.042 3.042 0 012.746-3.268h14.3a3.042 3.042 0 012.746 3.268",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38742",
  d: "M25.245 16.185h14.3a3.8 3.8 0 013.506 4.03v16.37l-.621.2a12.3 12.3 0 01-2.968.341 18.394 18.394 0 01-6.928-1.552 12.358 12.358 0 00-4.381-1.108 8.674 8.674 0 00-5.17 1.576l-1.246 1.027V20.215a3.8 3.8 0 013.508-4.03zm16.284 19.237V20.215a2.294 2.294 0 00-1.984-2.506h-14.3a2.294 2.294 0 00-1.984 2.506v13.87a10.789 10.789 0 014.893-1.146 13.666 13.666 0 014.924 1.208 16.9 16.9 0 006.386 1.452 11.333 11.333 0 002.065-.176z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38743",
  d: "M26.94 11.548h10.913a.887.887 0 01.874.74l.553 4.66H25.512l.553-4.66a.887.887 0 01.874-.74",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38744",
  d: "M26.942 10.786h10.91a1.644 1.644 0 011.626 1.376l.66 5.548H24.654l.655-5.512a1.652 1.652 0 011.633-1.412zm11.483 5.4l-.452-3.809-11.03-.068a.124.124 0 00-.123.1l-.447 3.773z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1471",
  d: "M35.641 15.011h-6.49a.762.762 0 01-.762-.762.762.762 0 01.762-.762h6.49a.762.762 0 01.762.762.762.762 0 01-.762.762z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1472",
  d: "M28.698 23.037h-6.2a.762.762 0 01-.761-.762.762.762 0 01.762-.762h6.2a.762.762 0 01.762.762.762.762 0 01-.763.762z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1473",
  d: "M28.698 25.965h-6.2a.762.762 0 01-.761-.762.762.762 0 01.762-.762h6.2a.762.762 0 01.762.762.762.762 0 01-.763.762z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1474",
  d: "M28.698 29.062h-6.2a.762.762 0 01-.761-.762.762.762 0 01.762-.762h6.2a.762.762 0 01.762.762.762.762 0 01-.763.762z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38745",
  d: "M25.288 59.999c-4.826 0-8.2-3.507-8.2-8.528V31.286a4.546 4.546 0 10-9.075 0v5.82a.762.762 0 11-1.524 0v-5.82a6.048 6.048 0 016-6.342h.169a6.1 6.1 0 015.957 6.341v20.186c0 4.19 2.681 7 6.672 7a5.956 5.956 0 006.346-6.179.762.762 0 111.524 0 7.5 7.5 0 01-7.869 7.707z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1475",
  d: "M32.396 47.479a.762.762 0 01-.762-.762v-3.615a.762.762 0 01.762-.762.762.762 0 01.762.762v3.615a.762.762 0 01-.762.762z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38746",
  d: "M33.79 52.009h-2.778a.885.885 0 01-.886-.885v-3.656a.885.885 0 01.886-.885h2.781a.885.885 0 01.885.885v3.656a.885.885 0 01-.885.885",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161178",
  d: "M31.008 45.821h2.782a1.649 1.649 0 011.647 1.647v3.653a1.649 1.649 0 01-1.647 1.65h-2.782a1.649 1.649 0 01-1.647-1.65v-3.653a1.649 1.649 0 011.647-1.647zm2.782 5.426a.124.124 0 00.123-.126v-3.653a.124.124 0 00-.124-.124h-2.781a.124.124 0 00-.124.124v3.653a.124.124 0 00.124.124z",
  fill: "#29398c"
}))));
export default __webpack_public_path__ + "static/icon-saline.58fe6ce366a3427e2a4b05b6d61fdbd0.svg";
export { SvgIconSaline as ReactComponent };